import type { CalendarProviderAccount } from '../store/schema/CalendarProviderAccount';
import type { CalendarProviderAccountInfo } from '../types/CalendarProviderAccountInfo';

export function createCalendarProviderAccount(
    account: CalendarProviderAccountInfo
): CalendarProviderAccount {
    const {
        id,
        calendarProviderType: providerType,
        userAccount: { emailAddress: userEmailAddress, displayName, state },
    } = account;

    return {
        id,
        providerType,
        displayName,
        userEmailAddress,
        state,
    };
}
